function t(t){const n=(t=t.replace(/[^\d]/g,"")).match(/\d{1,5}-?(\d{1,4})?/g);return n&&n.length>0&&(t=n[0].length<=5?n[0]:n[0].substring(0,5)+"-"+n[0].substring(5,9)),t}export{t as default};
